import axios from '@/config/api.request'

export default {
    // 查询最新一个加密货币团购返利摘要
    getLatestCryptoGroupRebateSummary() {
        return axios.request({
            url: '/crypto/group/rebate/latest/summary',
            method: 'get'
        })
    },
    // 根据加密货币主键查询加密货币团购返利摘要
    getCryptoGroupRebateSummary(cryptoId) {
        return axios.request({
            url: '/crypto/group/rebate/summary',
            method: 'get',
            params: { cryptoId }
        })
    },
    // 根据加密货币主键查询加密货币团购返利详情
    getCryptoGroupRebate(cryptoId) {
        return axios.request({
            url: '/crypto/group/rebate/rebate',
            method: 'get',
            params: { cryptoId }
        })
    }
}